import { type SRPSeriesTreeNode } from "../models/models";

export function initiallyExpandCategory(seriesTree: SRPSeriesTreeNode[], selectegCategories: string[]) {
  selectegCategories.forEach((category) => {
    seriesTree.forEach((node) => {
      expandCategoryRecursive(node, category);
    });
  });
}

function expandCategoryRecursive(node: SRPSeriesTreeNode, category: string): boolean {
  let shouldExpand;
  if (node.categoryCode === category) {
    shouldExpand = true;
  } else if (node.children.length > 0) {
    shouldExpand = node.children.some((child) => expandCategoryRecursive(child, category));
  } else {
    shouldExpand = false;
  }
  node.expanded = node.expanded || shouldExpand;
  return node.expanded;
}
